import { aggFuncForFeesBreakdown } from "features/fees/posted/PostedFeeChargeUtils";
import { useCallback } from "react";
import { DataTableProps } from "shared/components/table/data/DataTableProps";
import { GetLinkInfoForCellFn } from "shared/components/table/data/DataTableTypes";
import { rootRoute } from "shared/navigation/Routes";

export const useFeeChargeBreakdownTableProps = (
  fundFamilyId: string,
): Partial<DataTableProps> => {
  const getLinkInfoForCell = useCallback<GetLinkInfoForCellFn>(
    (props) => {
      if (
        props.type !== "data" ||
        props.cell.metadata?.type != "allocation_rule_link"
      ) {
        return undefined;
      }
      const allocationRuleId = props.cell.metadata.allocation_rule_id;
      return {
        type: "generic",
        to: rootRoute({})
          .fundFamilies({})
          .fundFamily({ fundFamilyId })
          .setup({})
          .entities({})
          .allocations({})
          .edit({ allocationRuleId })
          .investing({}).$,
      };
    },
    [fundFamilyId],
  );

  return {
    aggFunc: aggFuncForFeesBreakdown,
    getLinkInfoForCell,
  };
};
